import { useEffect, useRef } from "react";
import orderEcho from "../utils/orderEcho";

export default function useOrderSocket(onNewOrder) {
  const subscribedRef = useRef(false);

  useEffect(() => {
    if (!onNewOrder || subscribedRef.current) return;

    subscribedRef.current = true;
    const channelName = "orders.all";

    const channel = orderEcho.channel(channelName);

    channel.listen("order.created", (order) => {
      onNewOrder?.(order);
    });

    return () => {
      subscribedRef.current = false;
      orderEcho.leave(channelName);
    };
  }, [onNewOrder]);
}